var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6006 21.6293L19.0608 18.4768C19.6437 18.1403 19.9346 17.972 20.1465 17.7366C20.3341 17.5283 20.4759 17.283 20.5625 17.0164C20.6602 16.7158 20.6602 16.38 20.6602 15.7101V9.3959C20.6602 8.726 20.6602 8.39016 20.5625 8.0896C20.4759 7.82304 20.3341 7.57751 20.1465 7.36922C19.9355 7.13483 19.6453 6.96727 19.0674 6.63365L13.5996 3.47681C13.0167 3.14028 12.7259 2.97236 12.416 2.9065C12.1419 2.84822 11.8584 2.84822 11.5843 2.9065C11.2744 2.97236 10.9826 3.14028 10.3997 3.47681L4.93843 6.62988C4.35623 6.96602 4.06535 7.13395 3.85352 7.36922C3.66597 7.57751 3.52434 7.82304 3.43773 8.0896C3.33984 8.39087 3.33984 8.72758 3.33984 9.40064V15.7056C3.33984 16.3787 3.33984 16.7151 3.43773 17.0164C3.52434 17.283 3.66597 17.5283 3.85352 17.7366C4.06548 17.972 4.35657 18.1403 4.93945 18.4768L10.3997 21.6293C10.9826 21.9658 11.2744 22.1338 11.5843 22.1997C11.8584 22.2579 12.1419 22.2579 12.416 22.1997C12.7259 22.1338 13.0177 21.9658 13.6006 21.6293Z",
    stroke: "#0C056D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.553C9 14.2098 10.3431 15.553 12 15.553C13.6569 15.553 15 14.2098 15 12.553C15 10.8961 13.6569 9.55298 12 9.55298C10.3431 9.55298 9 10.8961 9 12.553Z",
    stroke: "#0C056D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconSettings);
export default __webpack_public_path__ + "static/media/NavIconSettings.d746c1ff31021fdd5ba3d8d0bde381e8.svg";
export { ForwardRef as ReactComponent };